/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_service_asset_management': {
    width: 20,
    height: 19,
    viewBox: '0 0 20 19',
    data: '<defs><path pid="0" d="M2 2h14v3H2V2zm6 8h14v3H8v-3zm-6 8h14v3H2v-3zM20.5 5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm-17 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm17 8a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" id="svgicon_icon_service_asset_management_a"/></defs><g transform="translate(-2 -2)" _fill="none" fill-rule="evenodd"><mask id="svgicon_icon_service_asset_management_b" _fill="#fff"><use xlink:href="#svgicon_icon_service_asset_management_a"/></mask><use _fill="#000" xlink:href="#svgicon_icon_service_asset_management_a"/><g mask="url(#svgicon_icon_service_asset_management_b)" _fill="#5D8BF8"><path pid="1" d="M0 0h24v24H0z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/components/icons/icon_service_asset_management.js